// extracted by mini-css-extract-plugin
module.exports = {"label":"_18NvNupJY22NfBM2gq6Jqd","sectionHeader":"_20z6B9uloT9AoQSmOpCwxC"};